export default {"src":"/_next/static/media/like.4b8838a5.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};